/**
 * Cross-module enums and metadata used by both reports and dashboards.
 * Single source of truth so renaming or restyling one constant updates
 * every chip / icon across both modules.
 */
import { Lock, Share2, Users, Globe } from 'lucide-react';

// Private — only you (+ explicit shares via the Share modal)
// Public  — everyone in your organization can view
// Groups  — members of the selected groups can view
export const VISIBILITY_OPTIONS = ['Private', 'Public', 'Groups'];

export const VISIBILITY_META = {
  Private: { icon: Lock, cls: 'text-slate-500 bg-slate-100', label: 'Private' },
  Shared: { icon: Share2, cls: 'text-blue-600 bg-blue-50', label: 'Shared' },
  Team: { icon: Users, cls: 'text-emerald-600 bg-emerald-50', label: 'Team' },
  Public: { icon: Globe, cls: 'text-purple-600 bg-purple-50', label: 'Public' },
};

export const CHART_TYPES = [
  { value: 'bar', label: 'Bar' },
  { value: 'line', label: 'Line' },
  { value: 'area', label: 'Area' },
  { value: 'pie', label: 'Pie' },
  { value: 'donut', label: 'Donut' },
  { value: 'funnel', label: 'Funnel' },
  { value: 'heatmap', label: 'Heatmap' },
  { value: 'kpi', label: 'KPI' },
];

export const CHART_TYPE_LABEL = CHART_TYPES.reduce(
  (acc, t) => { acc[t.value] = t.label; return acc; }, {},
);

export const CHART_PALETTE = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#06b6d4'];

export const SCHEDULE_FREQUENCIES = ['daily', 'weekly', 'monthly'];
export const SCHEDULE_FORMATS = ['PDF', 'Excel', 'CSV'];
export const SCHEDULE_TIMEZONES = ['Asia/Kolkata', 'America/New_York', 'Europe/London', 'America/Los_Angeles', 'UTC'];

// Object/field taxonomy. Used by builders and the object picker to render
// section headers and category chips. Backend objects without an explicit
// category fall through to 'CRM' so the UI always has a bucket.
export const OBJECT_CATEGORIES = ['CRM', 'Sales', 'Marketing', 'Support', 'Finance', 'Activities', 'Communication', 'Custom'];

export const FIELD_CATEGORY_LABELS = {
  standard: 'Standard Fields',
  custom: 'Custom Fields',
  formula: 'Formula Fields',
  related: 'Related Object Fields',
};
